angular.module 'app'

  .factory 'activeUser', ->
    {}